import  { useEffect } from "react";
import { HP_WEB_SERVICE_PORT } from "../../../utils/constants/others";

const OrderRedirection = () => {
  useEffect(() => {
    if (process.env.NODE_ENV === "development") {
      window.location.href = `http://localhost:${HP_WEB_SERVICE_PORT}/z/buyer/order`;
    } else {
      window.location.href = "/z/buyer/order";
    }
  }, []);

  return null;
};

export default OrderRedirection;
